import { useState } from 'react';
import CloseIcon from '@mui/icons-material/CloseRounded';
import LanguageIcon from '@mui/icons-material/LanguageOutlined';
import {
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

const DISMISS_KEY = 'campaign-send-from-custom-domain-nudge';

interface Props {
  onSetUp: () => void;
}

function CustomDomainNudge({ onSetUp }: Props) {
  const theme = useTheme();
  const [isDismissed, setIsDismissed] = useState(
    sessionStorage.getItem(DISMISS_KEY) === 'true',
  );

  if (isDismissed) return null;

  const onDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem(DISMISS_KEY, 'true');
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1.5}
      sx={{
        px: 2,
        py: 1.5,
        borderRadius: '10px',
        backgroundColor: theme.palette.lightGrey.main,
      }}>
      <LanguageIcon
        sx={{ fontSize: 18, color: 'text.secondary', flexShrink: 0 }}
      />
      <Box flex={1}>
        <Typography variant="caption" fontWeight={600} color="text.primary">
          Send from your own domain
        </Typography>
        <Typography
          variant="caption"
          display="block"
          lineHeight={1.5}
          color="text.secondary">
          Campaigns send from a Porter address until you connect a custom
          domain.
        </Typography>
      </Box>
      <Button variant="smallLink" onClick={onSetUp} sx={{ flexShrink: 0 }}>
        Set up
      </Button>
      <IconButton size="small" onClick={onDismiss} aria-label="Dismiss">
        <CloseIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
      </IconButton>
    </Stack>
  );
}

export default CustomDomainNudge;
